import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedItem: null,
  isOpenSubMenu: [],
}

const navigatorSlice = createSlice({
  name: 'navigator',
  initialState,
  reducers: {
    setSelectedItem: (state, { payload }) => {
      state.selectedItem = payload
    },
    setIsOpenSubMenu: (state, { payload }) => {
      state.isOpenSubMenu = payload
    },
  },
})

export const getSelectedItem = (state) => state.navigator.selectedItem
export const getIsOpenSubMenu = (state) => state.navigator.isOpenSubMenu

export const { setSelectedItem, setIsOpenSubMenu } = navigatorSlice.actions
export const navigator = navigatorSlice.reducer
